/**
 * Client-side validator for the CTA band's demo sign-up form
 * (template-parts/cta.php's `.js-cta-form`) — required-field + email-
 * format checks, same "demo until a real CF7 shortcode is set" pattern as
 * src/js/newsletter.js, but for this form's 3 fields instead of one.
 */
document.addEventListener("DOMContentLoaded", function () {
  var forms = document.querySelectorAll(".js-cta-form");
  if (!forms.length) {
    return;
  }

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  forms.forEach(function (form) {
    var msg = form.querySelector("[data-cta-form-msg]");

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      form.classList.remove("is-success", "is-error");

      var firstInvalid = null;
      form.querySelectorAll(".cta-form__input").forEach(function (field) {
        var value = field.value.trim();
        var isEmail = field.type === "email";
        var valid = value && (!isEmail || emailPattern.test(value));

        field.toggleAttribute("aria-invalid", !valid);
        if (!valid && !firstInvalid) {
          firstInvalid = field;
        }
      });

      if (firstInvalid) {
        form.classList.add("is-error");
        if (msg) {
          msg.textContent = "Please fill in every field with a valid value.";
        }
        firstInvalid.focus();
        return;
      }

      // No CRM/email service is connected yet — set a real CF7 shortcode
      // (wps_cta_shortcode) to replace this demo confirmation.
      form.classList.add("is-success");
      if (msg) {
        msg.textContent = "Thanks — we'll be in touch shortly.";
      }
      form.reset();
    });
  });
});
